/**
 * Created by Administrator on 2017/10/13.
 */
import {formatDate} from '../js/date.js';

export function formatPara (para) {
  if(para.start_time && typeof(para.start_time) != "string")
    para.start_time = formatDate(para.start_time, 'yyyy-MM-dd hh:mm:ss');

  if(para.end_time && typeof(para.end_time) != "string")
    para.end_time = formatDate(para.end_time, 'yyyy-MM-dd hh:mm:ss');

  if(typeof(para.update_time) === "string")
    para.update_time = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');

  if(!para.create_time)
    if(typeof(para.create_time) === "string")
      para.create_time = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
  return para;
}



// WEBPACK FOOTER //
// ./src/static/js/util.js